import { NextPage } from "next"
import { GardiaRequest } from "src/features/gardia-mci/components/GardiaRequest"
import { MciFactoringInspectionCsv } from "src/features/gardia-mci/components/MciFactoringInspectionCsv"
import Head from "next/head"
import { Heading } from "@smooth/design-system-components"
import { DefaultLayout } from "src/components/Layout"

/** admin のガルディア・MCI のページを移したもの。1 つのページに 2 つの操作を置く */
const GardiaMciPage: NextPage = () => (
  <DefaultLayout>
    <Head>
      <title>CIC CSV吐き出し | for Smoother</title>
    </Head>
    <div style={{ height: "calc(100vh - 90px)", overflowY: "auto" }}>
      <div data-smooth-ds className="mx-auto max-w-[900px] px-4 py-6 sm:px-6 lg:px-8">
        <div className="mb-6 flex flex-col gap-2">
          <Heading level={1}>CIC CSV吐き出し</Heading>
        </div>
        <div className="flex flex-col gap-8">
          <GardiaRequest />
          <MciFactoringInspectionCsv />
        </div>
      </div>
    </div>
  </DefaultLayout>
)

export default GardiaMciPage
